import React from "react";

import { RushaSvgIcon } from "./RushaSvgIcon";

/**
 * Dashboard icon — grid of 4 panels.
 *
 * Dual-tone layered style:
 * - 4 panels: top-left large, top-right small, bottom-right large, bottom-left medium
 * - Bottom-right panel has a purple accent fill at 8%
 * - All panel outlines in currentColor
 * - No node dots
 */
export const DashboardIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <RushaSvgIcon size={size}>
    {/* Purple accent fill on the bottom-right (large) panel */}
    <rect
      x="13"
      y="13"
      width="7"
      height="7"
      rx="1.5"
      fill="#a855f7"
      fillOpacity={0.08}
    />
    {/* Top-left large panel outline */}
    <rect
      x="3"
      y="3"
      width="8"
      height="10"
      rx="1.5"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Top-right small panel outline */}
    <rect
      x="13"
      y="3"
      width="8"
      height="8"
      rx="1.5"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Bottom-right large panel outline */}
    <rect
      x="13"
      y="13"
      width="8"
      height="8"
      rx="1.5"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Bottom-left medium panel outline */}
    <rect
      x="3"
      y="15"
      width="8"
      height="6"
      rx="1.5"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </RushaSvgIcon>
);

DashboardIcon.displayName = "DashboardIcon";

export default DashboardIcon;
